import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { money } from "@/context/StoreContext";
import { AdminCard, Badge } from "./AdminLayout";
import { DeleteButton } from "./ImageUpload";

export function AdminPayments() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Payments</h1>
      <AdminCard className="overflow-x-auto p-0">
        <table className="w-full text-sm min-w-[640px]"><thead className="bg-sharoa-ivory text-left text-xs uppercase text-sharoa-muted"><tr>{["Payment ID", "Order", "Customer", "Amount", "Method", "Status", "Date", ""].map((h, i) => <th key={i} className="py-3 px-4">{h}</th>)}</tr></thead>
          <tbody>{orders.map((o) => (
            <tr key={o.id} className="border-t border-sharoa-line">
              <td className="py-3 px-4 font-mono text-xs">{o.razorpay_payment_id || (o.payment_method === "cod" ? "COD" : "—")}</td>
              <td className="py-3 px-4 font-mono">{o.order_number}</td>
              <td className="py-3 px-4">{o.customer?.name}</td>
              <td className="py-3 px-4 font-mono">{money(o.total)}</td>
              <td className="py-3 px-4">{o.payment_method === "cod" ? "Cash on Delivery" : "Razorpay"}</td>
              <td className="py-3 px-4"><Badge tone={["paid", "cod_paid"].includes(o.payment_status) ? "green" : "amber"}>{o.payment_status}</Badge></td>
              <td className="py-3 px-4">{new Date(o.created_at).toLocaleDateString("en-IN")}</td>
              <td className="py-3 px-2"><DeleteButton label="payment record" testId={`delete-payment-${o.order_number}`} onDelete={async () => { await api.delete(`/admin/orders/${o.id}`); load(); }} /></td>
            </tr>
          ))}</tbody>
        </table>
      </AdminCard>
    </div>
  );
}

export function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Audit Logs</h1>
      <AdminCard className="overflow-x-auto p-0">
        <table className="w-full text-sm"><thead className="bg-sharoa-ivory text-left text-xs uppercase text-sharoa-muted"><tr>{["User", "Action", "Record", "Detail", "When"].map((h) => <th key={h} className="py-3 px-4">{h}</th>)}</tr></thead>
          <tbody>{logs.map((l) => (
            <tr key={l.id} className="border-t border-sharoa-line">
              <td className="py-2.5 px-4">{l.user}</td>
              <td className="py-2.5 px-4 capitalize">{l.action?.replace(/_/g, " ")}</td>
              <td className="py-2.5 px-4">{l.record_type} {l.record_id?.slice(0, 6)}</td>
              <td className="py-2.5 px-4 text-sharoa-muted">{l.detail}</td>
              <td className="py-2.5 px-4">{new Date(l.at).toLocaleString("en-IN")}</td>
            </tr>
          ))}</tbody>
        </table>
        {logs.length === 0 && <p className="p-6 text-sharoa-muted text-sm">No activity logged yet.</p>}
      </AdminCard>
    </div>
  );
}
